<button #originRef (click)="showPopover()" [class.bg-hover]="dropdownOpen" class="button" mat-icon-button type="button">
  <mat-icon  color="primary" [matBadgeHidden] = "notificationCount == 0" [matBadge]="notificationCount" matBadgeColor="warn" svgIcon="mat:notifications_active"></mat-icon>
</button>
